import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getConsumptionNumber(cookies, plantId, consumptionDate) {
    const url = `${apiBaseUrl}/consumption_notes/consumption_number/?plant_id=${plantId}&consumption_date=${consumptionDate}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getConsumptionPreview(cookies, params) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/consumption_notes/preview/?${query}`).then((r) => r.data);
}

export async function getProductionOptions(cookies, params) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/consumption_notes/production_options/?${query}`).then((r) => r.data);
}

export async function getStockStatement(cookies, plantId, asOnDate, mode = 'daily', options = {}) {
    const url = `${apiBaseUrl}/consumption_notes/stock_statement/?plant_id=${plantId}&as_on_date=${asOnDate}&mode=${mode}`;
    const requestOptions = options.silent ? { silent: true } : undefined;
    return getApiClient(cookies).get(url, requestOptions).then((r) => r.data);
}

export async function getConsumptionList(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/consumption_notes/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getConsumptionDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/consumption_notes/${id}/`).then((r) => r.data);
}

export function createConsumption(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/consumption_notes/`, payload).then((r) => r.data);
}

export function updateConsumption(cookies, id, payload) {
    return getApiClient(cookies).put(`${apiBaseUrl}/consumption_notes/${id}/`, payload).then((r) => r.data);
}

export function cancelConsumption(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/consumption_notes/${id}/`, {}).then((r) => r.data);
}

export function deleteConsumption(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/consumption_notes/${id}/`).then((r) => r.data);
}
